/**
 * @param {any[]} arr Array of objects
 * @param {string} property The key to extract from each object
 */
export const uniqueValuesByProperty = (arr, property) => {
    const mappedValues = arr.map(el => el[property]);
    const uniqueValues = new Set(mappedValues);
    return [...uniqueValues];
};

export const sumReduce = (total, current) => total + current;

/**
 * Given an array "arr", split it into arrays of size "itemsPerChunk"
 * @param arr The array to be chunked
 * @param itemsPerChunk How many items per array
 * @example
 * chunk([1,2,3,4,5], 2) // [[1,2], [3,4], [5]]
 */
export const chunk = (arr, itemsPerChunk) =>
    arr.reduce((resultArray, item, index) => {
        const chunkIndex = Math.floor(index / itemsPerChunk);

        if (!resultArray[chunkIndex]) {
            resultArray[chunkIndex] = []; // start a new chunk
        }

        resultArray[chunkIndex].push(item);

        return resultArray;
    }, []);
